export default __webpack_public_path__ + "static/media/battery.ac60be3a.gif";